import { render, staticRenderFns } from "./notifications-sidebar.vue?vue&type=template&id=10be5bed&"
import script from "./notifications-sidebar.vue?vue&type=script&lang=ts&"
export * from "./notifications-sidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports